import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/init";
export const getUserInfo = {
  data() {
    return {
      id: "",
      fullname: null,
      isAdmin: false,
      isStandard: false,
      initials: null,
      email: null,
    };
  },
  created() {
    if (firebase.auth().currentUser) {
      // if true, make request to data base to pull user information
      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then((doc) => {
          this.id = doc.id;
          this.email = doc.data().email;
          this.fullname = doc.data().fullname;
          this.isAdmin = doc.data().isAdmin;
          this.isStandard = true;
        })
        .then(() => {
          this.initials = this.fullname
            .match(/(\b\S)?/g)
            .join("")
            .match(/(^\S|\S$)?/g)
            .join("")
            .toUpperCase();
        });
    }
  },
};
